import { ProfileService } from './../../../services/profile/profile.service';
import { Component, OnInit } from '@angular/core';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { spreadsheetInterface } from 'src/app/util/interfaces/spreadsheet';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbStockReportPageService } from './service/cmdb-stock-report-page.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { Consumable } from 'src/app/util/interfaces/stockConsumables';

@Component({
	selector: 'app-cmdb-stock-report-page',
	templateUrl: './cmdb-stock-report-page.component.html',
	styleUrls: ['./cmdb-stock-report-page.component.scss'],
})
export class CmdbStockReportPageComponent implements OnInit {
	faAngleRight = faAngleRight;

	isLoadingReportList = false;
	isLoadingLabels = true;
	isLoadingRegisterFormOptions = false;

	consumablesInterface: Consumable[] = [];

	registerFormOptions: genericFormInterface[] = [];
	selectedFormOptions: genericFormInterface[] = [];

	labels: any = {
		lbl_edocs_carregando: 'Loading',
		lbl_geral_reports: 'Reports',
		lbl_create_report: 'Create new report',
		lbl_geral_voltar: 'Back',
		lbl_geral_campos_disponiveis: 'Available fields',
		lbl_incluir_campos_final_relatorio: 'Include fields in the filter, inclusions go to the end of the form',
		lbl_geral_criado_com_sucesso: 'Succesful created',
		lbl_campo_adicionado_no_final: 'Field added at the end of the form',
		lbl_geral_exportar_excel: 'Export to excel',
		lbl_geral_quantidade: 'Amount',
		lbl_geral_saida: 'Exit',
		lbl_geral_ativo: 'Active',
		lbl_geral_usuario: 'User',
		lbl_geral_data: 'Date',
		lbl_geral_identificacao: 'Identification',
		lbl_geral_responsavel: 'Responsible',
		lbl_geral_local: 'Location',
		lbl_geral_entrada: 'Entry',
		lbl_cmdb: 'CMDB',
		lbl_asset_consumiveis: 'Consumables',
		lbl_geral_data_retorno: 'Return date',
		lbl_geral_data_retorno_esperada: 'Expected return date',
		lbl_geral_movement_date: 'Movement date',
		lbl_filtros_aplicaveis: 'Applicable filters',
		lbl_geral_selecione_opcao_acima: 'Select an option above',
		lbl_geral_novos_itens: 'New items',
		lbl_selecione_filtro_info: "If you don't select a filter, the report will come with all available information.",
		lbl_projetos_nao_existe_item_parametros_pesquisa_requeridos: 'There are no items registered for the required search criteria.',
		lbl_stock_emprestimo: 'Lending',
		lbl_geral_quan_pen: 'Pending Quantity',
		lbl_selecione_para_continuar: '',
		lbl_geral_relatorio: 'Report',
	};

	constructor(
		private cmdbStockReportPageService: CmdbStockReportPageService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private ProfileService: ProfileService
	) {}

	teste = '';
	pageView = 'report-list';
	spreadsheetView = '';
	reportOptionArray = [
		{
			pageView: 'register',
			spreadsheetView: 'consumables',
			label: 'lbl_asset_consumiveis',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'newItems',
			label: 'lbl_geral_novos_itens',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'stockLoan',
			label: 'lbl_stock_emprestimo',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
	];

	isRegisterAdvancedOpen = true;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
	}

	getFormOptions(formOption: string): void {
		this.isLoadingRegisterFormOptions = true;
		this.cmdbStockReportPageService.getFormOptions(formOption).subscribe((registerFormOptions) => {
			this.registerFormOptions = registerFormOptions;
			this.registerFormOptions.sort((a, b) => {
				if (this.labels[a.label] > this.labels[b.label]) return 1;
				if (this.labels[a.label] < this.labels[b.label]) return -1;
				return 0;
			});
			this.isLoadingRegisterFormOptions = false;
		});
	}

	selectForm(formItem: genericFormInterface, notify?: boolean): void {
		this.selectedFormOptions.push(formItem);
		this.selectedFormOptions.sort((a, b) => {
			if (this.labels[a.label] > this.labels[b.label]) return 1;
			if (this.labels[a.label] < this.labels[b.label]) return -1;
			return 0;
		});
		if (notify === undefined || notify === true) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_campo_adicionado_no_final);
		}
	}

	unselectForm(formItem: any): void {
		for (const [index, selectedFormItem] of this.selectedFormOptions.entries()) {
			if (selectedFormItem === formItem) {
				formItem.values = [''];
				this.selectedFormOptions.splice(index, 1);
			}
		}
	}

	unselectAllForm(): void {
		this.isRegisterAdvancedOpen = true;
		this.selectedFormOptions = [];
		for (const formOption of this.registerFormOptions) {
			formOption.selected = false;
			formOption.values = [''];
		}
	}

	createReport(): void {
		this.cmdbStockReportPageService.createReport(this.spreadsheetView, this.selectedFormOptions).subscribe((retorno) => {
			if (retorno.length === 0) {
				return this.NotificationService.setNotificationMessage(
					this.labels.lbl_projetos_nao_existe_item_parametros_pesquisa_requeridos
				);
			} else {
				this.isLoadingReportList = true;
				this.unselectAllForm();
				this.pageView = 'spreadsheet';
				this.consumablesInterface = retorno;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.isLoadingReportList = false;
			}
		});
	}

	exportExcel(): void {
		this.cmdbStockReportPageService.exportExcel();
	}
}
